export const dotsThreeVerticalIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10.001 7.8a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4zm0-2.6a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 1 0 0 4.4zm0 9.6a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4z"/></svg>`,
  name: 'dots-three-vertical',
};
